export default __webpack_public_path__ + "static/media-2-8b3310ff03d37a40b16d7ab365fc43bb.png";